import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { api } from "../api/api";

export default function Betriebsurlaub() {
  const { user } = useAuth();
  const istAdmin = !!user?.isAdmin;

  const [urlaube,   setUrlaube]   = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [showForm,  setShowForm]  = useState(false);
  const [saving,    setSaving]    = useState(false);
  const [form,      setForm]      = useState({ urlaubVon: "", urlaubBis: "", beschreibung: "" });
  const [error,     setError]     = useState(null);

  useEffect(() => {
    api.betriebsurlaub.getAll()
      .then(setUrlaube)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.urlaubVon || !form.urlaubBis) { setError("Von- und Bis-Datum ausfüllen."); return; }
    if (form.urlaubBis < form.urlaubVon)    { setError("Bis-Datum muss nach Von-Datum liegen."); return; }
    setError(null); setSaving(true);
    try {
      await api.betriebsurlaub.create(form);
      const neu = await api.betriebsurlaub.getAll();
      setUrlaube(neu);
      setForm({ urlaubVon: "", urlaubBis: "", beschreibung: "" });
      setShowForm(false);
    } catch (err) {
      setError(err.message || "Fehler beim Speichern.");
    } finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!id) { alert("Ungültige ID – bitte Seite neu laden."); return; }
    if (!window.confirm("Betriebsurlaub wirklich löschen?")) return;
    try {
      await api.betriebsurlaub.delete(id);
      setUrlaube(prev => prev.filter(u => u.urlaubId !== id));
    } catch (err) {
      alert("Fehler beim Löschen: " + (err.message || "Unbekannter Fehler"));
    }
  };

  const heute = new Date();
  heute.setHours(0, 0, 0, 0);

  const fmt = (str) => new Date(str.slice(0, 10) + "T00:00:00").toLocaleDateString("de-DE", {
    day: "2-digit", month: "long", year: "numeric"
  });

  const getStatus = (u) => {
    const von = new Date(u.urlaubVon.slice(0, 10) + "T00:00:00");
    const bis = new Date(u.urlaubBis.slice(0, 10) + "T00:00:00");
    if (heute > bis)  return { label: "Vergangen",  bg: "#f5f5f5",  color: "#999" };
    if (heute >= von) return { label: "Aktuell 🏖️", bg: "#ede7f6",  color: "#6a1b9a" };
    const tage = Math.ceil((von - heute) / (1000 * 60 * 60 * 24));
    if (tage <= 30)   return { label: `In ${tage} Tagen`, bg: "#fff3e0", color: "#e65100" };
    return              { label: "Geplant",     bg: "#e8f5e9",  color: "#2e7d32" };
  };

  return (
    <div className="container" style={{ maxWidth: 760 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "1rem", marginTop: "1rem" }}>
        <h2 className="section-title" style={{ margin: 0 }}>🏖️ Betriebsurlaub</h2>
        {istAdmin && (
          <button onClick={() => { setShowForm(s => !s); setError(null); }} style={{
            padding: "0.45rem 1.1rem", borderRadius: "8px", border: "none",
            background: showForm ? "#e0e0e0" : "#1b5e20", color: showForm ? "#444" : "white",
            fontWeight: 700, cursor: "pointer", fontSize: "0.9rem",
          }}>
            {showForm ? "✕ Abbrechen" : "+ Urlaub hinzufügen"}
          </button>
        )}
      </div>

      {/* Admin-Formular */}
      {istAdmin && showForm && (
        <form onSubmit={handleSubmit} className="card" style={{ marginTop: "1.25rem", border: "1.5px solid #ce93d8", display: "flex", flexDirection: "column", gap: "0.75rem" }}>
          <h3 style={{ color: "#6a1b9a", margin: 0 }}>Neuer Betriebsurlaub</h3>
          {error && <div className="alert alert-error">{error}</div>}

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 1rem" }}>
            <div className="form-group" style={{ margin: 0 }}>
              <label>Von *</label>
              <input type="date" value={form.urlaubVon}
                onChange={e => setForm(f => ({ ...f, urlaubVon: e.target.value }))} required />
            </div>
            <div className="form-group" style={{ margin: 0 }}>
              <label>Bis *</label>
              <input type="date" value={form.urlaubBis}
                onChange={e => setForm(f => ({ ...f, urlaubBis: e.target.value }))} required />
            </div>
          </div>

          <div className="form-group" style={{ margin: 0 }}>
            <label>Beschreibung (optional)</label>
            <input value={form.beschreibung}
              onChange={e => setForm(f => ({ ...f, beschreibung: e.target.value }))}
              placeholder="z.B. Sommerurlaub 2025" />
          </div>

          <button type="submit" disabled={saving} style={{
            padding: "0.5rem 1.5rem", borderRadius: "8px", border: "none",
            background: "#6a1b9a", color: "white", fontWeight: 700, cursor: "pointer", alignSelf: "flex-start",
          }}>
            {saving ? "Speichern..." : "💾 Speichern"}
          </button>
        </form>
      )}

      {loading && <div style={{ textAlign: "center", color: "#888", padding: "3rem" }}>Wird geladen...</div>}

      {!loading && urlaube.length === 0 && (
        <div className="card" style={{ textAlign: "center", color: "#888", padding: "2rem", marginTop: "1.5rem" }}>
          Keine Betriebsurlaube eingetragen.
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: "1rem", marginTop: "1.5rem" }}>
        {[...urlaube].sort((a, b) => a.urlaubVon.localeCompare(b.urlaubVon)).map(u => {
          const status = getStatus(u);
          return (
            <div key={u.urlaubId} className="card" style={{ border: `1.5px solid ${status.bg === "#f5f5f5" ? "#e0e0e0" : status.bg}`, opacity: status.label === "Vergangen" ? 0.6 : 1 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "1rem" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                  <div style={{ fontSize: "2rem" }}>🏖️</div>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: "1.05rem", color: "#333" }}>
                      {fmt(u.urlaubVon)} – {fmt(u.urlaubBis)}
                    </div>
                    {u.beschreibung && (
                      <div style={{ color: "#666", fontSize: "0.9rem", marginTop: "0.2rem" }}>{u.beschreibung}</div>
                    )}
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", flexShrink: 0 }}>
                  <span style={{ background: status.bg, color: status.color, padding: "0.2rem 0.75rem", borderRadius: "20px", fontSize: "0.82rem", fontWeight: 600 }}>
                    {status.label}
                  </span>
                  {istAdmin && (
                    <button onClick={() => handleDelete(u.urlaubId)} style={{
                      background: "none", border: "1px solid #e57373", borderRadius: "6px",
                      color: "#c62828", cursor: "pointer", padding: "0.25rem 0.6rem", fontSize: "0.8rem",
                    }}>
                      🗑 Löschen
                    </button>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
